import React, { useEffect } from 'react';

const Toast = ({ 
  message, 
  isVisible, 
  onUndo, 
  onDismiss, 
  duration = 5000,
  type = "success"
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onDismiss?.();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onDismiss]);

  if (!isVisible) return null;

  return (
    <div 
      className="flex items-center justify-between gap-4 px-4 py-3 rounded-[20px] backdrop-blur-[50px] bg-[#252020]/30 animate-in slide-in-from-bottom-2 duration-150"
      style={{ 
        border: '0.5px solid rgba(255, 255, 255, 0.1)', 
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.3)' 
      }}
    >
      <p className="text-sm font-medium text-white flex-1">
        {message}
      </p>
      
      {onUndo && (
        <button
          onClick={onUndo}
          className="px-3 py-1.5 text-xs font-medium text-white bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
        >
          Undo
        </button>
      )}
    </div>
  );
};

export default Toast;